const template = `
query RankingStylists(
  $conditionParams: StylistConditionInput,
  $conditionTagIds: [Int],
  $paginationInput: PaginationInput!
) {
    rankingStylists(input: {
      stylistConditionParams: $conditionParams
      appearanceConditionTagIds: $conditionTagIds
      paginationInput: $paginationInput
    }) {
      id
      rating
      totalRatingCount
      isStudioAccount
      isGuarantee
      user {
        id
        name
        avatar
      }
      profession {
        name
      }
      studio {
        id
        name
        address
        rating
        totalRatingCount
        authorized
      }
      customCovers {
        postId
        coverUrl
      }
      stylistService {
        name
        minPrice
        maxPrice
      }
    }
  }
`

export default async function ranking({ conditionParams, conditionTagIds, limit, offset }) {
  const paginationInput = { offset, limit }
  const { rankingStylists } = await request(template, { conditionParams, conditionTagIds, paginationInput })
  return rankingStylists
}
